import React, { Component, useContext } from 'react'
import { LogoWithNoTagLine, PearWhite, DTIconDark } from './Image'
import { Layer, Heading, Sidebar, Nav, Box, Text, Main, ResponsiveContext } from 'grommet'
import PublishFiles from './components/PublishFiles'
import { ReceiversTable, StoresTable } from './components/Receivers'
import { BulkScanTable } from './components/BulkScan'
import { StipendReportTable } from './components/StipendReport'
import Logs from './components/Logs'
import { ErrorCard } from './components/Cards'
import { AppContext, AuthContext } from './libs/context'
import {
  Analytics,
  Apps,
  AppsRounded,
  Bug,
  BusinessService,
  Dashboard,
  Deliver,
  DocumentPdf,
  Flows as FlowsIcon,
  FormClose,
  Host,
  HostMaintenance,
  MailOption,
  Map,
  Menu,
  Network,
  Package,
  Phone,
  Raspberry,
  Rss,
  Schedule,
  SchedulePlay,
  Toast,
  User
} from 'grommet-icons'
import PropTypes from 'prop-types'
import { normalizeResponseData, processError } from './libs/error'
import { brandColors } from './libs/theme'
import { Switch, Route, withRouter } from 'react-router-dom'
import firebase from './libs/firebase'
import update from 'immutability-helper'
import Flows from './components/Flows'
import { MotionBox, MotionLayer } from './components/Motion'
import MoonLoader from 'react-spinners/MoonLoader'
import { AnimatePresence } from 'framer-motion'
import GeneratedFiles from './components/GeneratedFiles'
import { core, opsAPI } from './api/retail'
import { AuthUserMenu } from './components/User'
import { FirebaseBatchJobs } from './components/Firebase'
import Toasts from './components/Toasts'
import { DonationReport } from './components/Donations'
import { setStateToRemoveToast, setStateForNewToast, setStateForErrorResponse } from './libs/notify'
import { DashboardReportPage } from './components/Corporate'
import { ConditionalWrapper, RoundIconButton, SplashLoader } from './components/Common'
import { NetworkMap } from './components/Network'
import { MailableContactList } from './components/StorePosters'
import { TranscriptsTable } from './components/ProductTranscripts'
import { labelByMode } from './libs/common'
import { DonationDataForm } from './components/donationForm/DonationInputForm'

class App extends Component {
  static contextType = AuthContext

  showResponseAsError = setStateForErrorResponse.bind(this)
  showAsToast = setStateForNewToast.bind(this)
  removeToast = setStateToRemoveToast.bind(this)

  listeners = []
  state = {
    toasts: [],
    showMenu: false,
    authToken: null,
    authUser: null,
    error: null,
    fbTableMetrics: [],
    fbJobs: [],
    apiLoading: false,
    companies: {},
    stores: {},
    receivers: {},
    initialLoad: true,
    demoMode: true,
    donationFormOpen: false
  }
  cacheToLocal = (key, data, addMinutes = 30) => {
    const expireDate = new Date()
    expireDate.setMinutes(expireDate.getMinutes() + addMinutes)
    const cacheData = { data: data, expire_at: expireDate.getTime() }
    localStorage.setItem(key, JSON.stringify(cacheData))
  }
  getLocal = (key) => {
    const localData = localStorage.getItem(key)
    return JSON.parse(localData) ? localData : null
  }
  loadData = () => {
    this.loadFirebase()

    // if (this.props.authUser) {
    //   return
    // }
    this.setState({ apiLoading: true })

    const companies = opsAPI.getFromRetail('companies', {
      fields: ['id', 'name', 'logo_image_url']
    })
    const receivers = opsAPI.getFromRetail('receivers', {
      fields: ['id', 'name', 'receiver_type'],
      page_size: 9999
    })
    const stores = opsAPI.getFromRetail('stores', {
      fields: ['id', 'name', 'company_id'],
      page_size: 9999
    })

    const reasons = opsAPI.getFromRetail('reasons')

    const responses = Promise.all([companies, stores, receivers, reasons])
    responses
      .then((result) => {
        const companies = result[0].data
        const stores = result[1].data.results
        const receivers = result[2].data.results
        const reasons = result[3].data.results
        const companyIdMap = {}
        const storeIdMap = {}
        const receiverIdMap = {}
        const reasonsIdMap = {}
        companies.forEach((comp) => (companyIdMap[comp.id] = comp))
        stores.forEach((store) => (storeIdMap[store.id] = store))
        receivers.forEach((receiver) => (receiverIdMap[receiver.id] = receiver))
        reasons.forEach((reason) => (reasonsIdMap[reason.id] = reason))

        // this.cacheToLocal('companies', companyIdMap)
        this.setState({
          apiLoading: false,
          companies: companyIdMap,
          stores: storeIdMap,
          receivers: receiverIdMap,
          reasons: reasonsIdMap,
          initialLoad: false
        })
      })
      .catch((err) => {
        this.setState({ apiLoading: false })
        this.showResponseAsError(err)
      })
  }
  getCompanies = () => { }
  unsubscribe = () => {
    console.log('<<App>> Unsubscribing listeners', this.listeners)
    this.listeners.forEach((listener) => listener())
    this.listeners = []
  }
  componentWillUnmount() {
    this.unsubscribe()
  }
  getFirebaseJob = (id) => {
    return this.state.fbJobs.find((job) => job.id === id)
  }
  loadFirebase = () => {
    this.unsubscribe()
    console.log('<<App>> loadFirebase: snapshots')
    const subscribeMetrics = firebase
      .firestore()
      .collection('table_metrics')
      .onSnapshot((snapshot) => {
        const { fbTableMetrics } = this.state
        snapshot.docChanges().forEach((change) => {
          const doc = change.doc
          const data = doc.data()
          // console.log(change.type, doc.id, data)
        })
      })
    const subscribeTasks = firebase
      .firestore()
      .collection('tasks')
      .onSnapshot((snapshot) => {
        const { fbJobs } = this.state
        snapshot.docChanges().forEach((change) => {
          const doc = change.doc
          const data = doc.data()
          let updatedObj = null
          if (change.type === 'modified') {
            const index = fbJobs.findIndex((job) => job.id === doc.id)
            updatedObj = update(fbJobs, { [index]: { $set: { id: doc.id, ...data } } })
          }

          if (change.type === 'added') {
            updatedObj = update(this.state.fbJobs, { $push: [{ id: doc.id, ...data }] })
          }
          updatedObj && this.setState({ fbJobs: updatedObj })
          // console.log(change.type, doc.id, data)
        })
      })
    console.log('<<App>> loadFirebase: subscribe listeners')
    this.listeners.push(subscribeMetrics)
    this.listeners.push(subscribeTasks)
  }
  componentDidMount() {
    this.props.authUser && this.loadData()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.authUser !== this.props.authUser && this.props.authUser) {
      console.log('<<App>>: AuthUser Updated')
      this.setState({ initialLoad: true })
      this.loadData()
    }
  }

  render() {
    /* build values for an app level context that can be accessed easily in nested child components
     * This way we can trigger root functions in the app such as send error messages
     * */
    const { demoMode, actions } = this.context

    const appContextValue = {
      actions: {
        showResponseAsError: this.showResponseAsError,
        logout: this.props.logoutAction,
        getFirebaseJob: this.getFirebaseJob,
        showAsToast: this.showAsToast,
        setDemoMode: actions.setDemoMode
      },
      companies: this.state.companies,
      stores: this.state.stores,
      receivers: this.state.receivers,
      reasons: this.state.reasons,
      // demoMap: demoMap,
      demoMode: demoMode
    }
    const { error, toasts, showJobs, fbJobs, apiLoading, initialLoad, showMenu, donationFormOpen } = this.state
    const { authUser } = this.props
    return (
      <AppContext.Provider value={appContextValue}>
        {apiLoading ? (
          <Box fill align={'center'} justify={'center'}>
            {initialLoad && authUser && (
              <SplashLoader authUser={authUser} apiLoading={apiLoading} />
            )}
          </Box>
        ) : (
          <Box fill>
            <MeshHeader
              demoMode={demoMode}
              showMenuAction={() => this.setState({ showMenu: !showMenu })}
              authUser={authUser}
            >
              <FirebaseBatchJobs jobs={fbJobs} />
            </MeshHeader>
            <Box direction={'row'} fill background="light-1" overflow={'hidden'}>
              <MeshNav
                showMenuIfLayer={showMenu}
                demoMode={demoMode}
                iconColor={demoMode && 'dark-5'}
                setCloseAction={() => this.setState({ showMenu: false })}
              />
              <Switch>
                <Route path="/ops/retail/receivers" component={ReceiversTable} />
                {/*<Route exact path="/ops/product/transcripts" component={TranscriptsTable} />*/}
                <Route
                  path={`/ops/product/transcripts/:id?`}
                  render={(props) => <TranscriptsTable {...props} />}
                />
                <Route path="/ops/retail/stores" component={StoresTable} />
                <Route path="/ops/retail/no-pickups" component={BulkScanTable} />
                <Route path="/ops/retail/stipend-report" component={StipendReportTable} />

                <Route path="/ops/reports/publish" component={PublishFiles} />
                <Route path="/ops/reports/generated" component={GeneratedFiles} />
                <Route path="/ops/reports/mailable" component={MailableContactList} />
                <Route path="/ops/logs" component={Logs} />
                <Route path="/ops/flows" component={Flows} />
                <Route path="/ops/dashboard" component={DashboardReportPage} />
                <Route path="/ops/network" component={NetworkMap} />
                <Route exact path="/ops">
                  <Box pad={'xlarge'} fill background={'light-1'}>
                    <PearWhite />
                  </Box>
                </Route>

              </Switch>
            </Box>
          </Box>
        )}
        {error && (
          <Layer
            background={'none'}
            onEsc={this.showResponseAsError}
            onClickOutside={this.showResponseAsError}
          >
            <ErrorCard
              closeAction={this.showResponseAsError}
              {...error}
              logoutAction={this.props.logoutAction}
            />
          </Layer>
        )}
        {toasts && toasts.length > 0 && (
          <MotionLayer background={'none'} modal={false} position={'bottom-left'}>
            <Toasts toasts={toasts} removeAction={this.removeToast} />
          </MotionLayer>
        )}
      </AppContext.Provider>
    )
  }
}
const MeshNav = ({
  footer,
  showMenuIfLayer,
  position = 'left',
  setCloseAction,
  children,
  demoMode,
  iconColor
}) => {
  const size = useContext(ResponsiveContext)
  const condition = size === 'small'
  return (
    <ConditionalWrapper
      condition={condition}
      wrapper={(children) =>
        showMenuIfLayer ? (
          <MotionLayer
            position={position}
            full={'vertical'}
            responsive={false}
            modal
            // plain
            initial={{ opacity: 0, x: -270 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -270 }}
            transition={{ type: 'stiff', duration: 0.33 }}
            onEsc={setCloseAction}
            onClickOutside={setCloseAction}
          >
            {children}
          </MotionLayer>
        ) : null
      }
    >
      <Sidebar
        background={'light-2'}
        // elevation={'large'}

        border={{ side: 'right', color: 'light-4' }}
        width={{ min: '270px' }}
        responsive={false}
        elevation={size === 'small' ? 'xlarge' : undefined}
        // header={<Avatar src="//s.gravatar.com/avatar/b7fb138d53ba0f573212ccce38a7c43b?s=80" />}
        footer={footer}
      >
        <Main
          pad={{
            left: size === 'small' ? 'medium' : 'xsmall',
            right: 'small',
            top: size === 'small' ? 'xsmall' : 'medium'
          }}
        >
          <Nav gap={size === 'small' ? 'small' : 'xxsmall'} responsive={false}>
            {size === 'small' && (
              <Box direction={'row'} justify={'between'} align={'center'}>
                <Box width="100px" align={'start'} justify={'start'}>
                  <LogoWithNoTagLine />
                </Box>
                <RoundIconButton Icon={FormClose} onClick={setCloseAction} />
              </Box>
            )}
            <RoutedButton
              icon={<Dashboard color={iconColor} />}
              label={labelByMode('dashboard', demoMode)}
              path={'/ops/dashboard'}
              callback={setCloseAction}
            />
            <RoutedButton
              icon={<AppsRounded color={iconColor} />}
              label={labelByMode('clientApp', demoMode)}
              path={'/as_client'}
              callback={setCloseAction}
            />
            <RoutedButton
              path="/ops/retail/receivers"
              icon={<Deliver color={iconColor} />}
              label={labelByMode('receivers', demoMode)}
              callback={setCloseAction}
            />
            <RoutedButton
              path="/ops/retail/stores"
              icon={<Host color={iconColor} />}
              label={labelByMode('stores', demoMode)}
              callback={setCloseAction}
            />
            <RoutedButton
              path="/ops/retail/no-pickups"
              icon={<HostMaintenance color={iconColor} />}
              label={labelByMode('nopickup', demoMode)}
              callback={setCloseAction}
            />

            <RoutedButton
              path="/ops/retail/stipend-report"
              icon={<Analytics color={iconColor} />}
              label={labelByMode('stipened', demoMode)}
              callback={setCloseAction}
            />

            {/*<RoutedButton*/}
            {/*  path="/ops/reports/publish"*/}
            {/*  icon={<SchedulePlay />}*/}
            {/*  label="Publish"*/}
            {/*  callback={setCloseAction}*/}
            {/*/>*/}
            {/*<RoutedButton*/}
            {/*  path="/ops/reports/generated"*/}
            {/*  icon={<Schedule />}*/}
            {/*  label="Generated"*/}
            {/*  callback={setCloseAction}*/}
            {/*/>*/}
            <RoutedButton
              path="/ops/reports/mailable"
              icon={<Package color={iconColor} />}
              label={labelByMode('mailable', demoMode)}
              callback={setCloseAction}
            />
            <RoutedButton
              path="/ops/product/transcripts"
              icon={<Phone color={iconColor} />}
              label={labelByMode('transcripts', demoMode)}
              callback={setCloseAction}
            />

            <RoutedButton
              onClick={() => {
                window.open('https://connect.foodmesh.ca', '_blank')
              }}
              icon={<Map color={iconColor} />}
              // path={'/ops/network'}
              label={labelByMode('community', demoMode)}
              callback={setCloseAction}
            />
            {/*<RoutedButton*/}
            {/*  icon={<HostMaintenance />}*/}
            {/*  label="Logs"*/}
            {/*  path={'/ops/logs'}*/}
            {/*  callback={setCloseAction}*/}
            {/*/>*/}
            {/*<RoutedButton*/}
            {/*  icon={<FlowsIcon />}*/}
            {/*  label="Flows"*/}
            {/*  path={'/ops/flows'}*/}
            {/*  callback={setCloseAction}*/}
            {/*/>*/}

            {/*<AppContext.Consumer>*/}
            {/*  {({ actions }) => (*/}
            {/*    <>*/}
            {/*      <RoutedButton*/}
            {/*        callback={setCloseAction}*/}
            {/*        icon={<Bug />}*/}
            {/*        label="Error"*/}
            {/*        onClick={() => {*/}
            {/*          core*/}
            {/*            .getTable()*/}
            {/*            .then()*/}
            {/*            .catch((err) => actions.showResponseAsError(err))*/}
            {/*        }}*/}
            {/*      />*/}
            {/*      <RoutedButton*/}
            {/*        callback={setCloseAction}*/}
            {/*        icon={<Toast />}*/}
            {/*        label="Toast"*/}
            {/*        onClick={() => {*/}
            {/*          actions.showAsToast({*/}
            {/*            title: Math.random().toString(36).substring(7),*/}
            {/*            message:*/}
            {/*              'Testing a toasty message - ' + Math.random().toString(36).substring(7)*/}
            {/*          })*/}
            {/*        }}*/}
            {/*      />*/}
            {/*      <RoutedButton*/}
            {/*        callback={setCloseAction}*/}
            {/*        icon={<Rss />}*/}
            {/*        label="Sentry"*/}
            {/*        onClick={() => {*/}
            {/*          actions.sentry_error()*/}
            {/*        }}*/}
            {/*      />*/}
            {/*    </>*/}
            {/*  )}*/}
            {/*</AppContext.Consumer>*/}
            {children}
          </Nav>
        </Main>
      </Sidebar>
    </ConditionalWrapper>
  )
}
MeshNav.propTypes = {
  children: PropTypes.element,
  footer: PropTypes.element
}
const SidebarButton = ({ icon, label, history, path, onClick, callback, ...rest }) => {
  const onClickPush = (event) => {
    event.preventDefault()
    path ? history.push(path) : onClick()
    callback && callback()
  }
  return (
    <Box
      direction="row"
      hoverIndicator
      gap="medium"
      pad="small"
      round={'xsmall'}
      onClick={onClickPush}
      {...rest}
    >
      {icon}
      <Text weight={'bold'} size={'medium'} color={'dark-6'}>
        {label}
      </Text>
    </Box>
  )
}

SidebarButton.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  history: PropTypes.object,
  path: PropTypes.string,
  onClick: PropTypes.func
}
const RoutedButton = withRouter(SidebarButton)

const MeshHeader = ({ showMenuAction, children, authUser, demoMode }) => (
  <ResponsiveContext.Consumer>
    {(size) => (
      <Box
        border={{ side: 'bottom', color: 'dark-3' }}
        direction="row"
        background="dark-4"
        height={'60px'}
        align={'center'}
      >
        <Box direction="row" flex="grow" pad="small" gap="xxsmall" align={'center'}>
          {showMenuAction && size === 'small' && (
            <RoundIconButton color="mesh-green-3" onClick={showMenuAction} Icon={Menu} />
          )}
          {demoMode ? (
            <Box pad={{ top: '2px' }} height={'32px'} width={'32px'}>
              <DTIconDark />
            </Box>
          ) : (
            <Box pad={{ bottom: '6px' }} height={'32px'} width={'32px'}>
              <PearWhite />
            </Box>
          )}
          <Heading level={3} margin={'none'}>
            {demoMode
              ? labelByMode('platform', demoMode)
              : 'Ops' + (size !== 'small' ? ' Platform' : '')}
          </Heading>
        </Box>
        <Box flex={'grow'} pad="small" align={'end'}>
          {children}
        </Box>
        <Box
          fill="vertical"
          pad={{ horizontal: 'xsmall' }}
          width={size !== 'small' ? { min: 'xsmall' } : 'xxsmall'}
          background={'dark-1'}
        >
          <AuthUserMenu
            fill
            justifyContent={'between'}
            focusIndicator={false}
            dropProps={{
              margin: { top: 'xsmall' }
            }}
            authUser={authUser}
          />
        </Box>
      </Box>
    )}
  </ResponsiveContext.Consumer>
)

export default App
